import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { Button as MuiButton } from '@mui/material';
import styled from 'styled-components';

import { Icon } from 'components/ui';

const SMuiButton = styled(({ theme, ...props }) => <MuiButton {...props} />)`
  && {
    background: ${({ theme }) => theme.palette.colors.white};
    color: ${({ theme }) => theme.palette.colors.black100};
    text-transform: unset;
    :hover {
      color: ${({ theme }) => theme.palette};
    }
  }
`;

const BackButton: FC<Props> = (props) => {
  const { title, route, onClick } = props;
  const history = useHistory();

  const pushByRoute = () => route && history.push(route);

  return (
    <SMuiButton variant="contained" onClick={!route ? onClick : pushByRoute} data-id={props['data-id']}>
      <Icon icon="arrow-left" mr={10} /> {title}
    </SMuiButton>
  );
};

export default BackButton;

interface Props {
  title: string;
  route?: string;
  onClick?: () => void;
  'data-id'?: string;
}
